export default "__VITE_ASSET__DKMtlFph__"